export const CATEGORY_LABELS: Record<
  'compartido' | 'privado' | 'snippet' | 'mensaje' | 'studio',
  string
> = {
  compartido: 'Compartido',
  privado: 'Privado',
  snippet: 'Snippet',
  mensaje: 'Mensaje',
  studio: 'Studio',
};

export const METHOD_LABELS: Record<string, string> = {
  chunking: 'Chunks',
  table_extraction: 'Tablas',
  unstructured_extraction: 'Unstructured',
  skip_existing_chunks: 'Saltado',
};

export const STORAGE_KEY = 'mychat-drive-panel-state';
